var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM7.50012 10.5C7.36762 10.5 7.24062 10.4475 7.14663 10.3535L5.14663 8.35351C4.95113 8.15801 4.95113 7.84201 5.14663 7.64651C5.34212 7.45101 5.65812 7.45101 5.85362 7.64651L7.47563 9.26851L10.6236 5.67051C10.8061 5.46201 11.1216 5.44151 11.3291 5.62351C11.5371 5.80551 11.5581 6.12101 11.3766 6.32901L7.87663 10.329C7.78562 10.4335 7.65562 10.495 7.51712 10.4995C7.51112 10.5 7.50562 10.5 7.50012 10.5ZM1 8C1 4.14 4.14 1 8 1C11.86 1 15 4.14 15 8C15 11.86 11.86 15 8 15C4.14 15 1 11.86 1 8Z",
    fill: "#8E9AB3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3788:35084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM7.50012 10.5C7.36762 10.5 7.24062 10.4475 7.14663 10.3535L5.14663 8.35351C4.95113 8.15801 4.95113 7.84201 5.14663 7.64651C5.34212 7.45101 5.65812 7.45101 5.85362 7.64651L7.47563 9.26851L10.6236 5.67051C10.8061 5.46201 11.1216 5.44151 11.3291 5.62351C11.5371 5.80551 11.5581 6.12101 11.3766 6.32901L7.87663 10.329C7.78562 10.4335 7.65562 10.495 7.51712 10.4995C7.51112 10.5 7.50562 10.5 7.50012 10.5ZM1 8C1 4.14 4.14 1 8 1C11.86 1 15 4.14 15 8C15 11.86 11.86 15 8 15C4.14 15 1 11.86 1 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3788:35084)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedGrey);
export default __webpack_public_path__ + "static/media/approved-grey.7b48e53a672e421f5be9d68481714291.svg";
export { ForwardRef as ReactComponent };